<template>
  <div class="down-tree">
    <el-tree
      :data="data"
      :props="defaultProps"
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>
<script>
import bus from "@/assets/js/bus";

export default {
  name: "filteredStocks",
  data() {
    return {
      stock_models: [],
      data: [
        {
          index: 0,
          label: "",
          children: []
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  methods: {
    handleNodeClick(data) {
      console.log("xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
      console.log(data);
      //获取隐藏的index
      var index = data.index;
      bus.$emit("current_stock_model", this.stock_models[index]);
      // var code = nameAndCode.substring(
      //   nameAndCode.indexOf("(") + 1,
      //   nameAndCode.length - 1
      // );
      // console.log(code);
      // for (var i = 0; i < this.stock_models.length; i++) {
      //   console.log(this.stock_models[i].code);

      //   if (this.stock_models[i].code === code) {
      //     console.log("***********************************************");
      //     console.log(this.stock_models[i].code);
      //     console.log(this.stock_models[i].x);
      //     bus.$emit("current_stock_model", this.stock_models[i]);
      //     break;
      //   }
      // }
    }
  },

  created() {
    bus.$on("stock_models", data => {
      this.stock_models = data;
      if (this.data[0].children.length > 0) {
        this.data[0].children.length = 0;
      }

      for (var i = 0; i < this.stock_models.length; i++) {
        let obj = {
          index: i,
          label:
            this.stock_models[i].name + "(" + this.stock_models[i].code + ")"
        };
        console.log(this.stock_models[i].code);
        this.data[0].children.push(obj);
      }

      if (this.stock_models.length > 0) {
        this.data[0].label =
          this.stock_models[0].market + "(" + this.stock_models.length + ")";
      }

      //show the first one
      bus.$emit("current_stock_model", this.stock_models[0]);
    });
  },
  beforeDestroy() {
    bus.$off("打卡");
  }
};
</script>
<style>
.down-tree {
  height: 600px;

  display: block;

  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/StockTree.vue